import CondensationRiskModal from './containers/CondensationRiskModalContainer'

export default CondensationRiskModal
